/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-27 16:26:58
 * @Explain: 邮箱模板 - 类型声明
 */

// 新增占位符 - 声明
export type FormDataType = {
  id?: number;
  name: string;
  type: number;
  fileMsg: {
    /** 接口返回的文件名称 - 用于提交至接口使用 */
    fileName: string;
    count: number;
    deduplication: string,
    /** 本地上传的文件原始名称 - 用于显示在上传框中 */
    sourceName: string,
}[];
  replaceField: string;
  defaultValue: string;
};

// 占位符 - 类型 - 枚举
export enum PlaceholderTypeEnum {
  /** 模板变量 */
  TEMPLATE_VAR = 0,
  /** 固定变量 */
  FIXED = 1,
  /** 动态变量 */
  DYNAMIC = 2,
  /** 联系人 */
  CONTACT = 3,
}
